import { render, staticRenderFns } from "./ProductListPage.vue?vue&type=template&id=05a2e67a"
import script from "./ProductListPage.vue?vue&type=script&lang=js"
export * from "./ProductListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports